import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class LogicNot extends DesigntimeComponent {
    static staticName = "Logic: Not";
    static staticId = "logicNot";
    hasRuntimeView = false;

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {
        };

        this.params = {
            parameter1: { key: "url:monthlySpending", value: 0 }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("valueChangedEvent", this.onRuntimeChanged.bind(this));
        return $(`<div class='${this.type}'></div>`);
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.id == this.id)
            return;

        if (this.params.parameter1.key != eventParams.key) {
            return;
        }

        let res = !eventParams.value;
        this.eventBroker.fireValueChanged(this.id, "value", res);
    }

    output = [
        { name: "value", type: "bool" }
    ];
}

export { LogicNot }
